import React, { useCallback, useState } from 'react';
import { useFragment } from 'react-relay/hooks';

import { graphql } from 'babel-plugin-relay/macro';

import { PopperChatActivityReassign } from 'deprecated/query-triggers';

import { Avatar } from 'components/v2';
import { UseReduxMutationConfig } from 'hooks/useReduxMutation';

import { AvatarChatActivityReassign_ChatActivity$key } from './__generated__/AvatarChatActivityReassign_ChatActivity.graphql';
import AvatarNode, { AvatarNodeProps } from './AvatarNode';

export interface AvatarChatActivityReassignProps extends Omit<AvatarNodeProps, 'classes' | 'fragmentRef' | 'onClick'> {
  fragmentRef: AvatarChatActivityReassign_ChatActivity$key;
  mutationConfig?: UseReduxMutationConfig;
}

const AvatarChatActivityReassign: React.FC<AvatarChatActivityReassignProps> = ({
  fragmentRef,
  mutationConfig,
  ...rest
}) => {
  const chatActivity = useFragment<AvatarChatActivityReassign_ChatActivity$key>(
    graphql`
      fragment AvatarChatActivityReassign_ChatActivity on ChatActivity {
        _id
        assignee {
          ...AvatarNode_Node
        }
        groupAssignee {
          ...AvatarNode_Node
        }
      }
    `,
    fragmentRef,
  );
  const [anchorEl, setAnchorEl] = useState<any>();
  const assignee = chatActivity.assignee || chatActivity.groupAssignee;

  const handleOpen = useCallback(
    (event: React.MouseEvent) => {
      event.stopPropagation();
      event.preventDefault();
      setAnchorEl(event.currentTarget);
    },
    [setAnchorEl],
  );

  const handleClose = useCallback(() => {
    setAnchorEl(undefined);
  }, [setAnchorEl]);

  return (
    <>
      {assignee ? (
        <AvatarNode data-lh-id="chat-activity-reassign-avatar" fragmentRef={assignee} onClick={handleOpen} {...rest} />
      ) : (
        <Avatar data-lh-id="chat-activity-reassign-avatar" tooltip="Unassigned" onClick={handleOpen} {...rest} />
      )}
      {chatActivity && (
        <PopperChatActivityReassign
          chatActivityId={chatActivity._id}
          anchorEl={anchorEl}
          onClose={handleClose}
          onClickAway={handleClose}
          mutationConfig={mutationConfig}
        />
      )}
    </>
  );
};

export default AvatarChatActivityReassign;
